export enum GoogleTagManagerEventAction {
  Resume = 'Resume',
  Pause = 'Pause',
  Stop = 'Stop',
  PlayerSettingClick = 'Player Settings Click',
  ReactivationPopupShown = 'pop up shown',
  ReactivationSubscriptionClick = 'reactivate subscription click',
  ReactivationCancelButtonClick = 'cancel button click',
  MainCtaClick = 'main cta click',
  BodyCtaClick = 'body cta click',
  ExploreAllClick = 'explore all click',
  PopupEmailEntered = 'popup email entered',
  PopupSignup = 'Sign Up',
  PopupLoginClicked = 'popup login clicked',
  PopupClose = 'popup close',
  Signup = 'Signup',
  SignIn = 'Signin',
  Click = 'Click',
  PopupTelcoSelected = 'popup telco selected',
  PopupAccountCreated = 'popup account created',
  PopupClick = 'Popup-Click',
  Error = 'Error',
  Popup = 'Pop up',
  Navigation = 'Navigation',
  Download = 'Download',
  Search = 'Search',
  Video = 'Video',
}
